import { Avatar, Box, Button, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { SearchFilter } from "../../components";
import { config } from "../../config";
import { NetworkCall } from "../../networkcall";
import { NetWorkCallMethods, stringAvatar } from "../../utils";
import { ContactList } from "../timeline/components/contactList";
import { InspectionAssigneeStyles } from "./styles";

export const ExisitingInspector = ({ t, onClose = () => false, CheckContact = () => false }) => {
    const classes = InspectionAssigneeStyles()
    const [datas, setData] = React.useState(null);
    const [open, setOpen] = React.useState(null);
    const [offset, setOffset] = React.useState(0)
    const [search, setSearch] = React.useState("");
    const [list, setList] = React.useState([])

    //get contact
    const getContact = (offset, search, reload) => {
        const payload = {
            search: search,
            offset: offset,
            limit: 10
        }
        NetworkCall(
            `${config.api_url}/account/get_detail`,
            NetWorkCallMethods.post,
            payload,
            true,
            true,
            false
        ).then((response) => {
            if (reload) {
                setList(response?.data?.data?.contact)
            } else {
                setList([...list, ...response?.data?.data?.contact])
            }

        }).catch((err) => {
            console.log(err)
        })
    }
    //initial load
    React.useEffect(() => {
        getContact(0, "", false)
        // eslint-disable-next-line
    }, [])
    const handleClick = (event) => {
        setOpen(!open);
    };
    //on change 
    const onChange = (val) => {
        setData(val)
        handleClick()
    }
    // infinity scroll
    const fetchMoreData = () => {
        setOffset(offset + 10);
        getContact(offset + 10, search, false);
    };
    //on search
    const onSearch = (value) => {
        setSearch(value)
        getContact(offset, value, true)
    }
    //onSubmit
    const onSubmit = () => {
        CheckContact(datas?.id)
    }
    return (
        <Box p={2}>
            <Box height="230px">
                <Box onClick={handleClick}>
                    <SearchFilter value={search} handleChange={(value) => onSearch(value)} placeholder="Search Member Details" />
                </Box>
                <Box position="relative">
                    {
                        open &&
                        <Box className={classes.contactList}>
                            <InfiniteScroll
                                dataLength={list?.length ?? ""}
                                next={fetchMoreData}
                                hasMore={true}
                                height={150}
                            >
                                {
                                    list?.map((val) => {
                                        return (
                                            <ContactList value={datas} onClick={onChange} data={val} />
                                        )
                                    })
                                }
                            </InfiniteScroll>
                        </Box>
                    }
                    {
                        datas ?
                            <Box display="flex" alignItems="center" className={classes.selectedList}>
                                <Box padding="4px">
                                    <Avatar sx={{ height: "34px", width: "34px" }} src={datas?.image_url ?? null}  {...stringAvatar(datas?.name)} />
                                </Box>
                                <Box flexGrow={1} marginLeft="8px">
                                    <Typography className={classes.name}>{datas?.name}</Typography>
                                    <Stack spacing={1} direction="row" alignItems="center">
                                        <Typography className={classes.email}>{datas?.email_id}</Typography>
                                        <Box className={classes.dot} />
                                        <Typography className={classes.email}> {datas?.mobile_no_country_code} {datas?.mobile_no}</Typography>
                                    </Stack>
                                </Box>
                                <Box marginRight="8px">
                                    <IconButton size="small" onClick={() => setData(null)}>
                                        <img src="/images/delete.svg" alt="" />
                                    </IconButton>
                                </Box>
                            </Box>
                            :
                            <Box height="12px" />
                    }




                    <Box height="30px" />

                </Box>
            </Box>
            <Button className={classes.btn} onClick={onSubmit} variant="contained" fullWidth>{t("Assign Person")}</Button>
        </Box>
    )
}